import { useContext } from 'react'
import { IsInSideSheetContext } from '../context/IsInSideSheetContext'

export function useIsInSideSheet(): boolean {
  return useContext(IsInSideSheetContext)
}
